module.exports = __webpack_public_path__ + "img/fondo1.7e860c0d.svg";